import { Spin as AntdSpin, SpinProps } from 'antd';
import { FC } from 'react';

const Spin: FC<SpinProps> = (props) => {
  return <AntdSpin {...props} />;
};

export default Spin;
